<template>
  <v-date-picker
    v-model="date"
    :min="minDate"
    :max="maxDate"
    :locale="$i18n.locale"
    class="date-picker"
    color="primary"
  ></v-date-picker>
</template>

<script>
export default {
  props: {
    initDate: {
      required: false,
      default: null
    },
    minDate: {
      required: false,
      default: null
    },
    maxDate: {
      required: false,
      default: null
    }
  },
  computed: {
    date: {
      get() {
        return this.initDate;
      },
      set(date) {
        this.$emit("setdate", date);
      }
    }
  }
};
</script>

<style scoped>
.date-picker >>> .v-date-picker-title__date,
.date-picker >>> .v-date-picker-header__value button {
  text-transform: capitalize;
}
</style>
